import { AppStore } from "store";
import { makeAutoObservable, runInAction } from "mobx";
import { isHydrated, makePersistable } from "mobx-persist-store";
import { setAuthHeaders } from "api/baseApi";
import { IUserModel } from "@models/dto/Rocketta/LicenseServer/Models/Auth/IUserModel";

export default class AccountStore {
  public accessToken: string | undefined = undefined;
  public currentUser: IUserModel | undefined;
  private rootStore: AppStore;

  get isAuthenticated(): boolean {
    return !!this.accessToken;
  }

  get isHydrated(): boolean {
    return isHydrated(this);
  }

  public setCurrentUser(user: IUserModel): void {
    runInAction((): void => {
      this.currentUser = user;
    });
  }

  constructor(rootStore: AppStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);

    makePersistable(this, {
      name: "accountStore",
      properties: ["accessToken"],
      storage: window.localStorage,
    });
  }

  public signOut(): void {
    runInAction(() => {
      this.accessToken = null;
    });
  }

  public signIn(accessToken: string): void {
    runInAction((): void => {
      this.accessToken = accessToken;
      setAuthHeaders(accessToken);
    });
  }
}
